export default __webpack_public_path__ + "static/media/5.6cd516a2.jpeg";